import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// login
import LoginReducer from "./auth/login/reducer";

// register
import RegisterReducer from "./auth/register/reducer";

// userProfile
import ProfileReducer from "./auth/profile/reducer";

// Chat
import ChatReducer from "./chat/reducer";

// MailBox
import MailboxReducer from "./mailbox/reducer";

// Calendar
import CalendarReducer from "./calendar/reducer";

// Ecommerce
import EcommerceReducer from "./ecommerce/reducer";

// HR Managment
import HRManagmentReducer from "./hrManagement/reducer";

// Notes
import NotesReducer from "./notes/reducer";

// Social
import SocialReducer from "./social/reducer";

// Invoice
import InvoiceReducer from "./invoice/reducer";

// Users
import UsersReducer from "./users/reducer";

// Diamond
import DiamondReducer from "./diamond/reducer";

// Jewellery
import JewelleryReducer from "./jewellery/reducer";

//Discount
import DiscountReducer from "./discount/reducer";

//Forgot Password
import ForgotPasswordReducer from "./auth/forgotPassword/reducer";

import VerifyOtpReducer from "./auth/verifyOTP/reducer";

import UpdatePasswordReducer from "./auth/updatePassword/reducer";

import settingsReducer from "./settings/reducer";

import BlogReducer from "./blog/reducer";

import OrderReducer from "./order/reducer";

import RBACReducer from "./RBAC/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Register: RegisterReducer,
  Profile: ProfileReducer,
  Chat: ChatReducer,
  Mailbox: MailboxReducer,
  Calendar: CalendarReducer,
  Ecommerce: EcommerceReducer,
  HRManagment: HRManagmentReducer,
  Notes: NotesReducer,
  Social: SocialReducer,
  Invoice: InvoiceReducer,
  Users: UsersReducer,
  Diamond: DiamondReducer,
  Jewellery: JewelleryReducer,
  ForgotPassword: ForgotPasswordReducer,
  verifyOtp: VerifyOtpReducer,
  passwordUpdate: UpdatePasswordReducer,
  Discount: DiscountReducer,
  Settings: settingsReducer,
  Blog: BlogReducer,
  Order: OrderReducer,
  RBAC: RBACReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
